export const UserLoginsDbStoreName: string = "userLoginsDB";
export interface UserLoginsDb {
    Type: LoginType;
    id: number;
    Email: string;
    CompanyId?: string;
    ChosenModule: Module;
    CRP?: string;
    CR?: string;
}

export enum Module {
    LTRD = 1,
    ATD,
    PRA,
    Ald,
    Common
}

export enum LoginType {
    Company = 1,
    Individual = 2
}